import React from 'react';
import { motion } from 'framer-motion';
import { Coffee } from 'lucide-react';
export function WhyPrice() {
  return <section className="bg-light py-12 md:py-24 px-4" data-id="element-353">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto text-center" data-id="element-354">
        <div className="inline-flex items-center justify-center p-4 bg-white rounded-full mb-6 shadow-lg" data-id="element-355">
          <Coffee className="w-10 h-10 text-primary" data-id="element-356" />
        </div>

        <h2 className="text-3xl md:text-5xl text-dark font-display font-extrabold tracking-headline mb-6" data-id="element-357">
          ¿Por qué solo $6.36?
        </h2>

        <div className="bg-white rounded-[24px] border border-border shadow-lg p-8 md:p-12" data-id="element-358">
          <p className="text-xl md:text-2xl text-body leading-relaxed" data-id="element-359">
            La mayoría de los cursos cuestan $997. Mi mentor me enseñó que la
            mejor forma de ayudarte es dándote una victoria rápida. Por eso, el
            acceso hoy cuesta{' '}
            <span className="font-bold text-primary" data-id="element-360">
              lo mismo que un café en Starbucks: $6.36
            </span>
            .
          </p>
        </div>
      </motion.div>
    </section>;
}